export const BTAG_COOKIE_DAYS_TO_LIVE = 30;
export const COOKIES_DAYS_TO_LIVE = 365 * 15; // ~15 years
